import { z } from "zod";

export const listFormatEnum = z.enum(["carousel", "grid", "stacked_carousel"]);

export type ListFormat = z.infer<typeof listFormatEnum>;
